import { useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';

declare global {
  interface Window {
    onTelegramAuth?: (user: Record<string, unknown>) => void;
  }
}

interface Props {
  botUsername: string;
  onError?: (message: string) => void;
}

export function TelegramLoginButton({ botUsername, onError }: Props) {
  const { login } = useAuth();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!botUsername || !containerRef.current) return;

    window.onTelegramAuth = async (user) => {
      const ok = await login(user);
      if (!ok) onError?.('Доступ запрещён или ошибка авторизации');
    };

    containerRef.current.innerHTML = '';
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    containerRef.current.appendChild(script);

    return () => {
      delete window.onTelegramAuth;
    };
  }, [botUsername, login, onError]);

  if (!botUsername) {
    return (
      <p style={{ color: 'var(--danger)' }}>
        BOT_USERNAME не настроен в .env API
      </p>
    );
  }

  return <div ref={containerRef} />;
}
